export default "__VITE_ASSET__26419b37__"